import cookiesLogo from '../assets/images/cookies_logo.png';
import cookiesCover from '../assets/images/cookies_cover.png';
import cookiesCard from '../assets/images/cookies_card.png';
import saltWineLogo from '../assets/images/urban_south_logo.png';
import saltWineCover from '../assets/images/urban_south_cover.png';
import urbanSouthCard from '../assets/images/urban_south_card.png';
import bbqLogo from '../assets/images/bbq_logo.png';
import bbqCover from '../assets/images/bbq_cover.png';
import bbqCard from '../assets/images/bbq_card.png';
import vibeLogo from '../assets/images/vibehair_logo.png';
import vibeCover from '../assets/images/vibehair_cover.png';
import vibeCard from '../assets/images/vibe_hair_card.png';

export const PageButtons = {
  dashboard: ['create-promotion', 'create-store'],
};
export const pages = [
  {
    id: 'dashboard',
    name: 'Dashboard',
    file: 'dashboard',
    roles: ['bp_user', 'store_user'],
    navigations: true,
    live: true,
  },
  {
    id: 'stores',
    name: 'stores',
    file: 'stores',
    roles: ['bp_user', 'store_user'],
    navigations: true,
    live: true,
  },
  {
    id: 'emailverification',
    name: 'EmailVerification',
    file: 'emailverification',
    roles: ['bp_user'],
    navigations: false,
    live: true,
  },
  {
    id: 'create-profile',
    name: 'Create Profile',
    file: 'create-profile',
    roles: ['bp_user'],
    navigations: false,
    live: true,
  },
  {
    id: 'profile-created',
    name: 'Profile Created',
    file: 'profile-created',
    roles: ['bp_user'],
    navigations: false,
    live: true,
  },
  {
    id: 'store-groups',
    name: 'Store Groups',
    file: 'store-groups',
    roles: ['bp_user', 'store_user'],
    navigations: true,
    live: true,
  },
  {
    id: 'promotions',
    name: 'Promotions',
    file: 'promotions',
    roles: ['bp_user', 'store_user'],
    navigations: true,
    live: true,
  },
  {
    id: 'store-managers',
    name: 'Store Managers',
    file: 'store-managers',
    roles: ['bp_user', 'store_user'],
    navigations: true,
    live: true,
  },
  {
    id: 'statements',
    name: 'Statements',
    file: 'statements',
    roles: ['bp_user', 'store_user'],
    navigations: true,
    live: true,
  },
  {
    id: 'profile',
    name: 'Profile',
    file: 'profile',
    roles: ['bp_user', 'store_user'],
    navigations: true,
    live: true,
    profile: true,
  },
  {
    id: 'payment-history',
    name: 'Payment History',
    file: 'payment-history',
    roles: ['bp_user', 'store_user'],
    navigations: true,
    live: true,
  },
  {
    id: 'card-detail',
    name: 'Card Detail',
    file: 'card-detail',
    roles: ['bp_user'],
    navigations: false,
    live: true,
  },
];
export const SelectProvince = [
  { value: 'All', label: 'All' },
  { value: 'AB', label: 'Alberta' },
  { value: 'BC', label: 'British Columbia' },
  { value: 'MB', label: 'Manitoba' },
  { value: 'NB', label: 'New Brunswick' },
  { value: 'NL', label: 'Newfoundland & Labrador' },
  { value: 'NT', label: 'Northwest Territories' },
  { value: 'NS', label: 'Nova Scotia' },
  { value: 'ON', label: 'Ontario' },
  { value: 'PE', label: 'Prince Edward Island' },
  { value: 'QC', label: 'Quebec' },
  { value: 'SK', label: 'Saskatchewan' },
  { value: 'YT', label: 'Yukon Territory' },
];

export const Cities = {
  All: ['All'],
  AB: [
    'Airdrie',
    'Grande Prairie',
    'Red Deer',
    'Beaumont',
    'Hanna',
    'St. Albert',
    'Bonnyville',
    'Hinton',
    'Spruce Grove',
    'Brazeau',
    'Irricana',
    'Strathcona County',
    'Breton',
    'Lacombe',
    'Strathmore',
    'Calgary',
    'Leduc',
    'Sylvan Lake',
    'Camrose',
    'Lethbridge',
    'Swan Hills',
    'Canmore',
    'McLennan',
    'Taber',
    'Didzbury',
    'Medicine Hat',
    'Turner Valley',
    'Drayton Valley',
    'Olds',
    'Vermillion',
    'Edmonton',
    'Onoway',
    'Wood Buffalo',
    'Ft. Saskatchewan',
    'Provost',
  ],
  BC: [
    'Burnaby',
    'Lumby',
    'City of Port Moody',
    'Cache Creek',
    'Maple Ridge',
    'Prince George',
    'Castlegar',
    'Merritt',
    'Prince Rupert',
    'Chemainus',
    'Mission',
    'Richmond',
    'Chilliwack',
    'Nanaimo',
    'Saanich',
    'Clearwater',
    'Nelson',
    'Sooke',
    'Colwood',
    'New Westminster',
    'Sparwood',
    'Coquitlam',
    'North Cowichan',
    'Surrey',
    'Cranbrook',
    'North Vancouver',
    'Terrace',
    'Dawson Creek',
    'North Vancouver',
    'Tumbler',
    'Delta',
    'Osoyoos',
    'Vancouver',
    'Fernie',
    'Parksville',
    'Vancouver',
    'Invermere',
    'Peace River',
    'Vernon',
    'Kamloops',
    'Penticton',
    'Victoria',
    'Kaslo',
    'Port Alberni',
    'Whistler',
    'Langley',
    'Port Hardy',
  ],
  MB: [
    'Birtle',
    'Flin Flon',
    'Swan River',
    'Brandon',
    'Snow Lake',
    'The Pas',
    'Cranberry Portage',
    'Steinbach',
    'Thompson',
    'Dauphin',
    'Stonewall',
    'Winnipeg',
  ],
  NB: [
    'Cap-Pele',
    'Miramichi',
    'Saint John',
    'Fredericton',
    'Moncton',
    'Saint Stephen',
    'Grand Bay-Westfield',
    'Oromocto',
    'Shippagan',
    'Grand Falls',
    'Port Elgin',
    'Sussex',
    'Memramcook',
    'Sackville',
    'Tracadie-Sheila',
  ],
  NL: [
    'Argentia',
    'Corner Brook',
    'Paradise',
    "Bishop's Falls",
    'Labrador City',
    'Portaux Basques',
    'Botwood',
    'Mount Pearl',
    "St. John's",
    'Brigus',
  ],
  NT: ['Town of Hay River', 'Town of Inuvik', 'Yellowknife'],
  NS: [
    'Amherst',
    'Hants County',
    'Pictou',
    'Annapolis',
    'Inverness County',
    'Pictou County',
    'Argyle',
    'Kentville',
    'Queens',
    'Baddeck',
    'County of Kings',
    'Richmond',
    'Bridgewater',
    'Lunenburg',
    'Shelburne',
    'Cape Breton',
    'Lunenburg County',
    'Stellarton',
    'Chester',
    'Mahone Bay',
    'Truro',
    'Cumberland County',
    'New Glasgow',
    'Windsor',
    'East Hants',
    'New Minas',
    'Yarmouth',
    'Halifax',
    'Parrsboro',
  ],
  ON: [
    'Ajax',
    'Halton',
    'Peterborough',
    'Atikokan',
    'Halton Hills',
    'Pickering',
    'Barrie',
    'Hamilton',
    'Port Bruce',
    'Belleville',
    'Hamilton-Wentworth',
    'Port Burwell',
    'Blandford-Blenheim',
    'Hearst',
    'Port Colborne',
    'Blind River',
    'Huntsville',
    'Port Hope',
    'Brampton',
    'Ingersoll',
    'Prince Edward',
    'Brant',
    'James',
    'Quinte West',
    'Brantford',
    'Kanata',
    'Renfrew',
    'Brock',
    'Kincardine',
    'Richmond Hill',
    'Brockville',
    'King',
    'Sarnia',
    'Burlington',
    'Kingston',
    'Sault Ste. Marie',
    'Caledon',
    'Kirkland Lake',
    'Scarborough',
    'Cambridge',
    'Kitchener',
    'Scugog',
    'Chatham-Kent',
    'Larder Lake',
    'Souix Lookout CoC Sioux Lookout',
    'Chesterville',
    'Leamington',
    'Smiths Falls',
    'Clarington',
    'Lennox-Addington',
    'South-West Oxford',
    'Cobourg',
    'Lincoln',
    'St. Catharines',
    'Cochrane',
    'Lindsay',
    'St. Thomas',
    'Collingwood',
    'London',
    'Stoney Creek',
    'Cornwall',
    'Loyalist Township',
    'Stratford',
    'Cumberland',
    'Markham',
    'Sudbury',
    'Deep River',
    'Metro Toronto',
    'Temagami',
    'Dundas',
    'Merrickville',
    'Thorold',
    'Durham',
    'Milton',
    'Thunder Bay',
    'Dymond',
    'Nepean',
    'Tillsonburg',
    'Ear Falls',
    'Newmarket',
    'Timmins',
    'East Gwillimbury',
    'Niagara',
    'Toronto',
    'East Zorra-Tavistock',
    'Niagara Falls',
    'Uxbridge',
    'Elgin',
    'Niagara-on-the-Lake',
    'Vaughan',
    'Elliot Lake',
    'North Bay',
    'Wainfleet',
    'Flamborough',
    'North Dorchester',
    'Wasaga Beach',
    'Fort Erie',
    'North Dumfries',
    'Waterloo',
    'Fort Frances',
    'North York',
    'Waterloo',
    'Gananoque',
    'Norwich',
    'Welland',
    'Georgina',
    'Oakville',
    'Wellesley',
    'Glanbrook',
    'Orangeville',
    'West Carleton',
    'Gloucester',
    'Orillia',
    'West Lincoln',
    'Goulbourn',
    'Osgoode',
    'Whitby',
    'Gravenhurst',
    'Oshawa',
    'Wilmot',
    'Grimsby',
    'Ottawa',
    'Windsor',
    'Guelph',
    'Ottawa-Carleton',
    'Woolwich',
    'Haldimand-Norfork',
    'Owen Sound',
    'York',
  ],
  PE: ['Alberton', 'Montague', 'Stratford', 'Charlottetown', 'Souris', 'Summerside', 'Cornwall'],
  QC: [
    'Alma',
    'Fleurimont',
    'Longueuil',
    'Amos',
    'Gaspe',
    'Marieville',
    'Anjou',
    'Gatineau',
    'Mount Royal',
    'Aylmer',
    'Hull',
    'Montreal',
    'Beauport',
    'Joliette',
    'Montreal Region',
    'Bromptonville',
    'Jonquiere',
    'Montreal-Est',
    'Brosssard',
    'Lachine',
    'Quebec',
    'Chateauguay',
    'Lasalle',
    'Saint-Leonard',
    'Chicoutimi',
    'Laurentides',
    'Sherbrooke',
    'Coaticook',
    'LaSalle',
    'Sorel',
    'Coaticook',
    'Laval',
    'Thetford Mines',
    'Dorval',
    'Lennoxville',
    'Victoriaville',
    'Drummondville',
    'Levis',
  ],
  SK: [
    'Avonlea',
    'Melfort',
    'Swift Current',
    'Colonsay',
    'Nipawin',
    'Tisdale',
    'Craik',
    'Prince Albert',
    'Unity',
    'Creighton',
    'Regina',
    'Weyburn',
    'Eastend',
    'Saskatoon',
    'Wynyard',
    'Esterhazy',
    'Shell Lake',
    'Yorkton',
    'Gravelbourg',
  ],
  YT: ['Carcross', 'Whitehorse'],
};
export const SelectCity = Object.entries(Cities)
  .map(([key, value]) =>
    value.map((city, index) => ({
      label: city,
      value: city?.toLowerCase() === 'all' ? key + index : key + index + 1,
      myValue: key,
    })),
  )
  .flat();

export const SelectOfferType = [
  { value: 'dollarBased', label: 'Minimum amount spent- $ based' },
  { value: 'percentBased', label: 'Minimum amount spent- % based' },
  { value: 'repeatVisit', label: 'Minimum amount spent- Repeat visit' },
  { value: 'initialOffer', label: 'Initial Offer' },
];

export const dummySlides = [
  {
    name: 'Big Fat Cookies',
    card_image_url: cookiesCard,
    font_color: '#ffffff',
    plastk_points_value: 500,
    business_logo_url: cookiesLogo,
    banner_image_url: cookiesCover,
    offer_short_text: 'Spend at least $80.00 and earn 500 Plastk Reward Points.',
  },
  {
    name: 'Salt Wine Bar',
    card_image_url: urbanSouthCard,
    font_color: '#ffffff',
    plastk_points_value: 1500,
    business_logo_url: saltWineLogo,
    banner_image_url: saltWineCover,
    offer_short_text: 'Spend at least $60.00 and earn 1,500 Plastk Reward Points.',
  },
  {
    name: 'Conspiracy Comics',
    card_image_url: vibeCard,
    font_color: '#ffffff',
    plastk_points_value: 300,
    business_logo_url: vibeLogo,
    banner_image_url: vibeCover,
    offer_short_text: 'Spend at least $25.00 and earn 300 Plastk Reward Points.',
  },
  {
    name: 'Blackjack BBQ',
    card_image_url: bbqCard,
    font_color: '#ffffff',
    plastk_points_value: 4000,
    business_logo_url: bbqLogo,
    banner_image_url: bbqCover,
    offer_short_text: 'Dine with a group of 4 and earn 4000 Plastk Reward Points.',
  },
];
